import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from './redux/store';
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));

// ไม่ใช้ PersistGate เพราะ loading={null} ทำให้แอปหายไปชั่วคราว
// redux-persist rehydrate sessionStorage ภายใน ~5ms แล้ว React จะ re-render เอง
// Sidebar จะแสดง skeleton animation แทนที่จะเป็นหน้าว่างสนิท
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// ยังต้อง flush persistor เพื่อให้ข้อมูลบันทึก sessionStorage ถูกต้อง
persistor.subscribe(() => {});

reportWebVitals();
